import { InjectionToken } from '@angular/core';

export const refreshApiConfigToken = new InjectionToken<string>(
  'Refresh API Config Per Deployment Environment'
);

